{
  "listViewHeaderDef": {
    "id": {
      "name": "ID",
      "id": "tm-list-view-th-id",
      "order": 1,
      "width": "25%",
      "colType": "link",
      "isSort": "false",
      "cssClass": ["link-primary", "text-truncate", "cursor-pointer"]
    },
    "createdAgo": {
      "name": "Created",
      "id": "tm-list-view-th-created",
      "order": 2,
      "isSort": "false"
    },
    "expiresAt": {
      "name": "Expires",
      "id": "tm-list-view-th-expires",
      "order": 3,
      "isSort": "false"
    }
  }
}
